(function (fox, $, undefined) {
	'use strict';

	const AutoLoginService = require('../../../site/root/components/auto-login')(fox);
	
	var _ = {
		ALIAS_GIFT_PREFIX: 'gift-',

		EVENT_GIFTSENDED: 'giftSended',
		EVENT_GIFTPAID: 'giftPaid',
		EVENT_GIFTSAVAILABLE: 'giftsAvailable',
	};
	
	fox.registerWidget('Giftbox', {
		configure: function () {
			this.checkedGifts = [];
			this.pendingPayment = [];

			this.registerOptions('', {
				autoRender: true,
				template: 'ls_viewer_sidebar_giftbox',
				widgets: {
					giftboxList: {
						widget: 'AdvancedList',
						'embed.container': '#gift-list-container',
						'tpl.row': 'ls_viewer_sidebar_giftbox_list_row',
						autoRender: true,
						collection: [{loader: true}]
					},
					cbPaymentPopup: {
						widget: 'CBPaymentPopup'
					},
				},
				handleDom: {
					sendGifts: {
						event: 'click',
						target: '#send-gift',
						callback: 'sendGiftConfirmed'
					},
					checkGift: {
						event: 'click',
						target: '.gift-item',
						targetWidget: '#giftboxList',
						callback: 'checkGiftSingle'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);
			const pm = fox.site.wom1('.PermissionManager');
			if (pm.hasAccess('guest'))	{
				this.autoLoginService = new AutoLoginService(this);
				this.registerOptions('#cbPaymentPopup', {
					matchTokenFunction: token => this.autoLoginService.matchToken(token)
				});
			}
			this.ga = fox.wom.selectFirst('@root #googleAnalytics');
			this.typeAlias = this.requireOption('giftType');
			this.gifts = null;

			this.handleEvent(
				'@root #socket',
				this.requireOption('giftPaymentSuccess'),
				'giftPaymentSuccess',
				{
					alwaysActive: true
				}
			);
		},

		running: function () {
			this.fetchGifts().then(function (gifts) {
				this.rwom1('#giftboxList').resetCollection(gifts);
				this.dispatchEvent(_.EVENT_GIFTSAVAILABLE);
			}.bind(this));

			this.callParent('running', arguments);
		},

		fetchGifts: function () {
			var api = this.getApi('getGifts', {method: 'gift.get', cacheChannel: 'site'});

			return api.psend({
				typeAlias: this.typeAlias
			}).then(function (res) {
				res = res.params.answer.response;

				var gifts = [];
			
			
				fox.each(res, function (item) {
					var amount = parseFloat(item.amount);
					var price = ((amount ^ 0) === amount) ? parseInt(amount) : amount.toFixed(2);
					gifts.push({
						id: item.giftId,
						alias: _.ALIAS_GIFT_PREFIX + item.giftId,
						price: price
					});
				});

				this.gifts = gifts;

				return fox.clone(gifts);
			}.bind(this));
		},

		getGifts: function () {
			return this.gifts;
		},

		_getGift: function (id) {
			var gifts = this.getGifts();

			for (var i = 0; i < gifts.length; i++) {
				if (gifts[i].id === id) {
					return gifts[i];
				}
			}

			return false;
		},

		prepareParams: function() {},

		sendGiftConfirmed(el, alias, performer, event) {
			event.preventDefault();
			event.stopPropagation();
			if (fox.isEmpty(this.checkedGifts)) {
				if (!!this.getOption('showUnchecked')) {
					const showUnchecked = this.getOption('showUnchecked');
					showUnchecked();
				}
				return false
			}
			const pm = fox.site.wom1('.PermissionManager');
			const isGuestUser = pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo());
			let prepareUserPromise = fox.Promise.resolve([true]);

			if (isGuestUser) {
				const showRegForm = this.getOption('userRegistration');
				this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueGuest', eventAction: 'FirstSendClick' });
				prepareUserPromise = showRegForm();
			} else {
				if (this.getParent().alias === "valentinesGiftsPopup")
					this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueMember', eventAction: 'SendClick' });
			}
			
			return prepareUserPromise.then((result) => {
				if (!result)
					return [false];
				else
					return this.sendGifts({ ...result }, el);
			});
		},

		sendGifts: function (data, btn) {
			const payGift = (id) => {
				var getTargetId = this.requireOption('targetIdCb');
				var api = this.getApi('payGift', {method: 'gift.pay'});
				
				var giftParams = {
					giftId: id,
					targetId: getTargetId(),
					typeAlias: this.typeAlias
				};

				if (!fox.isEmpty(data))
					giftParams = fox.merge(giftParams, data);

				var linkerParam = fox.wom.selectFirst('@root #googleAnalytics').getLinkerParam();

				if (linkerParam) {
					giftParams['transitParams[_ga]'] = linkerParam;
				}

				this.pendingPayment.push(id);

				const cbPaymentPopup = this.rwom1('#cbPaymentPopup');

				this.hookWrapper('prepareParams', giftParams);

				this.__prepareTransactionProgress = api.psend(giftParams, undefined, {prefix: 'waitForPay_' + id}).then(fox.bind(function (res) {
					delete this.__prepareTransactionProgress;

					res = res.params.answer.response;

					this.dispatchEvent(_.EVENT_GIFTSENDED);

					if (res.submit_url !== undefined) {
						return res;
					}
				}, this)).catch(fox.bind(function () {
					delete this.__prepareTransactionProgress;

					cbPaymentPopup.hide();
					this.pendingPayment.splice(this.pendingPayment.indexOf(id), 1);

					this.dispatchEvent(_.EVENT_GIFTSENDED);
				}, this));

				return this.__prepareTransactionProgress;
			}

			const [checkedId] = this.checkedGifts;

			this.showCbWindow(payGift(checkedId)).then(() => {
				this.resetCheckedGifts();
			}, () => {
				this.resetCheckedGifts();
			});
			
			
		},

		giftPaymentSuccess: function (res) {
			var args = Array.prototype.slice.call(arguments);
			var cbPaymentPopup = this.rwom1('#cbPaymentPopup');

			if (this.__prepareTransactionProgress) {
				return this.__prepareTransactionProgress.then(() => {
					return this.giftPaymentSuccess.apply(this, args);
				});
			}

			if (cbPaymentPopup.isOpen())
				cbPaymentPopup.hide();

			res = parseInt(res.answer);
			var indx = this.pendingPayment.indexOf(res);

			if (indx !== -1) {
				this.pendingPayment.splice(indx, 1);

				var gift = this._getGift(res);

				if (gift !== false) {
					this.dispatchEvent(_.EVENT_GIFTPAID, [[gift.alias, gift.price].join(':')]);
				}
			}
		},

		showCbWindow: function (promise) {
			var cbPaymentPopup = this.rwom1('#cbPaymentPopup');
		
			return cbPaymentPopup.show(
				promise.then((params) => {
					var url = params.submit_url + '?' + fox.toQueryString(params.added_fields);

					return { url };
				})
			)
		},

		checkGiftSingle: function (el, alias, performer) {
			var $el = $(el);

			if (!$el.hasClass('gift-item')) {
				$el = $el.parents('.gift-item');
			}

			var gid = $el.data('gid');
			var gift = this._getGift(gid);
			var indx;
			var checked;
			var $old;

			if (gift !== false) {
				indx = this.checkedGifts.indexOf(gid);

				if (indx === -1) {
					checked = this.checkedGifts.pop();

					if (checked !== undefined) {
						$old = $(performer.dom1('[data-gid="' + checked + '"]'));
						$old.removeClass('active');
					}

					this.checkedGifts.push(gid);
					$el.addClass('active');
				} else {
					this.checkedGifts.splice(indx, 1);
					$el.removeClass('active');
				}
			}
		},

		checkGiftMultiple: function (el) {
			var
				$el = $(el),
				gid = $el.data('gid'),
				gift = this._getGift(gid),
				indx
			;

			if (gift !== false) {
				indx = this.checkedGifts.indexOf(gid);

				if (indx === -1) {
					this.checkedGifts.push(gid);
					$el.addClass('active');
				} else {
					this.checkedGifts.splice(indx, 1);
					$el.removeClass('active');
				}
			}
		},

		showSuccessPopup: function() {
			this.dispatchEvent('giftPaid');
		},

		resetCheckedGifts: function() {
			this.checkedGifts = [];

			this.wom1('#giftboxList')
				.dom('[data-gid]')
				.forEach(elm => { $(elm).removeClass('active') })

		} 

	}, 'Widget');

})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/widget/Giftbox.es.js